import { AlgChannelService } from './channel.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from '../../../shared';

@Injectable({ providedIn: 'root' })
export class TwilioVoiceService extends AlgChannelService {
  loginSubjectUuid = localStorage.getItem('guid');
  tenantCode = sessionStorage.getItem('tenantCode');

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE +"twilio-api/voice";
    this.httpClient = httpClient;
  }

  public generateToken(virtualPhoneNumber, apiVisa?: ApiVisa) {
    let api = this.apiUrl + '/token';
    return this.httpClient.get(
      api,
      this.getHttpHeaderForVoice(virtualPhoneNumber, apiVisa)
    );
  }

  public call(data, virtualPhoneNumber, apiVisa?: ApiVisa): Observable<any> {
    let api = this.apiUrl + '/call';
    return this.httpClient.post(
      api,
      data,
      this.getHttpHeaderForVoice(virtualPhoneNumber, apiVisa)
    );
  }

  getHttpHeaderForVoice(phoneNumber, apiVisa?: ApiVisa) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'tenant-code': apiVisa?.tenantCode,
        'token': apiVisa?.jwt_secret,
        'phoneNumber': phoneNumber,
        'loginSubjectUuid' : this.loginSubjectUuid,
      })
    };
    return httpOptions;
  }
}
